import { object, string, number, array, boolean, InferType } from 'yup'
import { DispatcherScope, EquipmentType } from './constants'

const emptyStringToNull = <T extends string>(value: T, originalValue: T): null | T => {
  if (typeof originalValue === 'string' && originalValue === '') {
    return null
  }
  return value
}
export const AddLaneAlertModalSchema = object({
  pickupCity: string().required('Please enter a pickup location.'),
  pickupStateCode: string(),
  pickupMiles: number(),
  pickupStartDate: string().transform(emptyStringToNull).nullable(true),
  pickupEndDate: string().transform(emptyStringToNull).nullable(true),
  pickupIsoDaysOfWeek: array().of(number()).nullable(true),
  deliveryCity: string().transform(emptyStringToNull).nullable(true),
  deliveryStateCode: string().transform(emptyStringToNull).nullable(true),
  deliveryMiles: number().transform(emptyStringToNull).nullable(true),
  trailerType: string()
    .oneOf(Object.values(EquipmentType))
    .transform(emptyStringToNull)
    .nullable(true)
    .required('Please select an Equipment Type'),
  loadedMilesMin: number()
    .nullable(true)
    .transform((_, val) => (val == null ? null : val)),
  loadedMilesMax: number()
    .nullable(true)
    .transform((_, val) => (val == null ? null : val)),
  dispatcherScope: string()
    .oneOf(Object.values(DispatcherScope))
    .required('Please select an option'),
  subscriberParentIds: array()
    .of(number())
    .when('dispatcherScope', {
      is: DispatcherScope.specificDispatchers,
      then: array().of(number()).required('Please select at least one recipient').min(1),
    }),
  // Virtual fields
  dropoffPreference: boolean().when(['loadedMilesMin', 'loadedMilesMax', 'deliveryCity'], {
    is: (loadedMilesMin, loadedMilesMax, deliveryCity) => {
      return !loadedMilesMin && !loadedMilesMax && !deliveryCity
    },
    then: boolean().required('Please select a Dropoff Preference.'),
  }),
  pickupAvailability: boolean().when(['pickupIsoDaysOfWeek', 'pickupStartDate', 'pickupEndDate'], {
    is: (pickupIsoDaysOfWeek, pickupStartDate, pickupEndDate) =>
      (!pickupIsoDaysOfWeek && !pickupStartDate) || (!pickupIsoDaysOfWeek && !pickupEndDate),
    then: boolean().required('Please select at least one option.'),
  }),
})

export type TAddLaneAlertModalSchema = InferType<typeof AddLaneAlertModalSchema>
